var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessTick = function SvgSuccessTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00AC75",
    d: "m12.871 21.38 10.085-10.084-1.581-1.58-8.504 8.503-4.275-4.275-1.58 1.581zm2.132 7.87q-2.957 0-5.558-1.122a14.4 14.4 0 0 1-4.526-3.045 14.4 14.4 0 0 1-3.047-4.524Q.75 17.959.75 15.003t1.122-5.558a14.4 14.4 0 0 1 3.045-4.526 14.4 14.4 0 0 1 4.524-3.047Q12.041.75 14.997.75t5.558 1.122a14.4 14.4 0 0 1 4.526 3.045 14.4 14.4 0 0 1 3.047 4.524q1.122 2.6 1.122 5.556t-1.122 5.558a14.4 14.4 0 0 1-3.045 4.526 14.4 14.4 0 0 1-4.524 3.047q-2.6 1.122-5.556 1.122"
  })));
};
export default SvgSuccessTick;